// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentNewsArticle_container__1zP07","content":"RecentNewsArticle_content__VBL8s"};